import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addPageAction } from '@nike/ux-tread-new-relic';
import { getByPath } from './shared-utils';

// Map of error codes that cause us to remove the product from the user's cart:
var notBuyableCodes = {
  PRODUCT_NOT_BUYABLE: true,
  OUT_OF_STOCK: true
};
var quantityLimitCodes = {
  ITEM_QUANTITY_LIMIT: true
};
var promoCodeErrorCodes = {
  PROMOTION_INVALID: true,
  PROMOTION_EXPIRED: true
};
var EVENT_NAME = 'Handling Cart Error';

/**
 * @ignore
 * @returns {Promise} result of handling cart errors
 */
export default function handleCartErrors(_x, _x2) {
  return _handleCartErrors.apply(this, arguments);
}
function _handleCartErrors() {
  _handleCartErrors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, queryClient) {
    var _error$data, _error$data2;
    var error, params, data, errors, itemsToRemove, hasOverLimitItems, hasNonBuyableItems, hasInvalidPromoCodes, handleRemovePromotionCode, handleMergeCarts, _data$items, items, _items$, handleRemoveItem, _data$items2, _items$2, _items, _handleRemoveItem, _handleMergeCarts, _data$items3, _items2$, _items2, _handleRemoveItem2, _handleRemovePromotionCode, _handleMergeCarts2, _handleRemovePromotionCode2, _data$items4, _items3$, _items3, _handleRemoveItem3, _handleMergeCarts3, _handleRemovePromotionCode3;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          error = _ref.error, params = _ref.params;
          // Normalize common fetch/mutation error shapes into one cart+errors payload.
          data = error !== null && error !== void 0 && error.data && ((error === null || error === void 0 || (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.resourceType) === 'cart' || Array.isArray(error === null || error === void 0 || (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.items)) ? error.data : error;
          errors = (error === null || error === void 0 ? void 0 : error.errors) || (data === null || data === void 0 ? void 0 : data.errors); // 2. check for errors
          if (!(errors && errors.length)) {
            _context.next = 32;
            break;
          }
          // 3. reduce over errors that have fields
          itemsToRemove = errors.filter(function (e) {
            return e.field && typeof e.field === 'string';
          }).reduce(function (accum, curr) {
            // 4. check codes to see which errors need to be worked on
            var shouldFilterProduct = notBuyableCodes[curr.code] || quantityLimitCodes[curr.code] || promoCodeErrorCodes[curr.code];

            // 5. from the field string target the item by skuId eg:'item/0/skuId' | '/promotionCodes/0'
            // Add safety check to ensure field can be split and joined properly
            try {
              var fieldPath = curr.field.split('/').filter(function (x) {
                return x;
              }).join('.');
              if (!fieldPath) {
                // Invalid field path, skip this error
                addPageAction(EVENT_NAME, {
                  error: 'Invalid field path in error',
                  field: curr.field,
                  code: curr.code,
                  message: curr.message
                });
                return accum;
              }
              var filteredField = getByPath(data, fieldPath);

              // 6. if filtered field is a number
              var isANumber = !isNaN(filteredField) && filteredField !== undefined && filteredField !== null;
              if (isANumber) {
                // 7. from the field string target the line item id eg:'item/0/quantity'
                var lineItemId = curr.field.split('/').filter(function (x) {
                  return x;
                }).join('.').replace('quantity', 'id');
                var shouldAdjustQuantity = getByPath(data, lineItemId);

                // 8. if theres an error to be addressed
                return shouldFilterProduct ? _objectSpread(_objectSpread({}, accum), {}, {
                  reduceQuantity: _objectSpread(_objectSpread({}, accum.reduceQuantity), {}, _defineProperty({}, shouldAdjustQuantity, true))
                }) : accum;
              }

              // 10. if filtered field is not a number and there's an error to be addressed
              if (shouldFilterProduct) {
                if (promoCodeErrorCodes[curr.code]) {
                  return _objectSpread(_objectSpread({}, accum), {}, {
                    invalidPromoCodes: [].concat(_toConsumableArray(accum.invalidPromoCodes), [filteredField // 11. accumulate invalid promoCodes here
                    ])
                  });
                }
                return _objectSpread(_objectSpread({}, accum), {}, {
                  notBuyableSkus: _objectSpread(_objectSpread({}, accum.notBuyableSkus), {}, _defineProperty({}, filteredField, true))
                });
              }
              return accum;
            } catch (fieldError) {
              // If there's an error processing this field, log it and skip this error
              addPageAction(EVENT_NAME, {
                error: 'Error processing error field',
                field: curr.field,
                code: curr.code,
                message: curr.message,
                fieldError: fieldError.message
              });
              return accum;
            }
          }, {
            invalidPromoCodes: [],
            notBuyableSkus: {},
            reduceQuantity: {}
          }); // 13. determine if cart has any items over limit or has any non buyable items
          hasOverLimitItems = Object.keys(itemsToRemove.reduceQuantity).length > 0;
          hasNonBuyableItems = Object.keys(itemsToRemove.notBuyableSkus).length > 0;
          hasInvalidPromoCodes = itemsToRemove.invalidPromoCodes.length > 0; // 14. if there are invalid promos only
          if (!(hasInvalidPromoCodes && !hasNonBuyableItems && !hasOverLimitItems)) {
            _context.next = 3;
            break;
          }
          addPageAction(EVENT_NAME, {
            error: 'Invalid promotion codes detected',
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 1:
          handleRemovePromotionCode = _context.sent["default"];
          _context.next = 2;
          return handleRemovePromotionCode(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 2:
          // 16. and in all cases afterwards, propagate the errors up
          errors.map(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 3:
          if (!(hasOverLimitItems && !hasNonBuyableItems && !hasInvalidPromoCodes)) {
            _context.next = 6;
            break;
          }
          addPageAction(EVENT_NAME, {
            error: 'Items over quantity limit detected',
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            errors: errors,
            data: data
          });
          _context.next = 4;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 4:
          handleMergeCarts = _context.sent["default"];
          _context.next = 5;
          return handleMergeCarts({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 5:
          // 19. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 6:
          if (!(hasNonBuyableItems && !hasOverLimitItems && !hasInvalidPromoCodes)) {
            _context.next = 9;
            break;
          }
          items = ((_data$items = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items !== void 0 ? _data$items : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          if (!items.length) {
            _context.next = 9;
            break;
          }
          addPageAction(EVENT_NAME, {
            error: 'Non-buyable items detected',
            nonBuyableItems: items.map(function (item) {
              return item.skuId;
            }),
            errors: errors,
            data: data
          });
          _context.next = 7;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 7:
          handleRemoveItem = _context.sent["default"];
          _context.next = 8;
          return handleRemoveItem(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.id
          }));
        case 8:
          // 22. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 9:
          if (!(hasNonBuyableItems && hasOverLimitItems && !hasInvalidPromoCodes)) {
            _context.next = 14;
            break;
          }
          _items = ((_data$items2 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items2 !== void 0 ? _data$items2 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          addPageAction(EVENT_NAME, {
            error: 'Both non-buyable items and items over quantity limit detected',
            nonBuyableItems: _items.map(function (item) {
              return item.skuId;
            }),
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            errors: errors,
            data: data
          });
          _context.next = 10;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 10:
          _handleRemoveItem = _context.sent["default"];
          _context.next = 11;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 11:
          _handleMergeCarts = _context.sent["default"];
          if (!(_items.length && (_items$2 = _items[0]) !== null && _items$2 !== void 0 && _items$2.id)) {
            _context.next = 12;
            break;
          }
          _context.next = 12;
          return _handleRemoveItem(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items[0].id
          }));
        case 12:
          _context.next = 13;
          return _handleMergeCarts({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 13:
          // 26. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 14:
          if (!(hasNonBuyableItems && !hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.next = 19;
            break;
          }
          _items2 = ((_data$items3 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items3 !== void 0 ? _data$items3 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          addPageAction(EVENT_NAME, {
            error: 'Both non-buyable items and invalid promotion codes detected',
            nonBuyableItems: _items2.map(function (item) {
              return item.skuId;
            }),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.next = 15;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 15:
          _handleRemoveItem2 = _context.sent["default"];
          _context.next = 16;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 16:
          _handleRemovePromotionCode = _context.sent["default"];
          if (!(_items2.length && (_items2$ = _items2[0]) !== null && _items2$ !== void 0 && _items2$.id)) {
            _context.next = 17;
            break;
          }
          _context.next = 17;
          return _handleRemoveItem2(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items2[0].id
          }));
        case 17:
          _context.next = 18;
          return _handleRemovePromotionCode(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 18:
          // 30. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 19:
          if (!(!hasNonBuyableItems && hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.next = 24;
            break;
          }
          addPageAction(EVENT_NAME, {
            error: 'Both items over quantity limit and invalid promotion codes detected',
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.next = 20;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 20:
          _handleMergeCarts2 = _context.sent["default"];
          _context.next = 21;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 21:
          _handleRemovePromotionCode2 = _context.sent["default"];
          _context.next = 22;
          return _handleMergeCarts2({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 22:
          _context.next = 23;
          return _handleRemovePromotionCode2(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 23:
          // 34. then propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 24:
          if (!(hasNonBuyableItems && hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.next = 31;
            break;
          }
          _items3 = ((_data$items4 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items4 !== void 0 ? _data$items4 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          addPageAction(EVENT_NAME, {
            error: 'Multiple cart issues detected: non-buyable items, items over quantity limit, and invalid promotion codes',
            nonBuyableItems: _items3.map(function (item) {
              return item.skuId;
            }),
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.next = 25;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 25:
          _handleRemoveItem3 = _context.sent["default"];
          _context.next = 26;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 26:
          _handleMergeCarts3 = _context.sent["default"];
          _context.next = 27;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 27:
          _handleRemovePromotionCode3 = _context.sent["default"];
          if (!(_items3.length && (_items3$ = _items3[0]) !== null && _items3$ !== void 0 && _items3$.id)) {
            _context.next = 28;
            break;
          }
          _context.next = 28;
          return _handleRemoveItem3(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items3[0].id
          }));
        case 28:
          _context.next = 29;
          return _handleMergeCarts3({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 29:
          _context.next = 30;
          return _handleRemovePromotionCode3(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 30:
          // 39. then propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 31:
          errors.forEach(function (err) {
            var message = err.message,
              crcCode = err.crcCode,
              code = err.code,
              field = err.field;
            // 40. if we have errors after handling the above cases afterwards, propagate them up
            addPageAction(EVENT_NAME, {
              error: 'Unhandled cart error',
              errorCode: code,
              errorMessage: message,
              crcCode: crcCode,
              field: field,
              errors: errors,
              data: data
            });
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.abrupt("return", error);
        case 32:
          // 41. if no errors, then propagate the entire error up
          addPageAction(EVENT_NAME, {
            error: 'General cart error without error details',
            errorMessage: error.message || 'Unknown error',
            errors: errors,
            data: data
          });

          // Return error data for handling RQ errors
          return _context.abrupt("return", error);
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _handleCartErrors.apply(this, arguments);
}